import { apiClient } from "@/api/api-client";
import { truncateName } from "@/api/helper";
import { Form } from "@/components/core/forms/form.tsx";
import { caseStages } from "@/constants/case-stages";
import CaseStageChart from "@/features/overview/components/case-stage-chart";
import { IconTrendingUp } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Line, LineChart, ResponsiveContainer, Tooltip } from "recharts";

export default function CaseOccStatsModal({ id }: { id: string }) {
	const [pending, setPending] = useState(0);
	const [closed, setClosed] = useState(0);

	const fetchCaseCount = async () => {
		const response = await apiClient.get(
			`/backoffice/case-records-breakdown-branch/${id}`,
		);
		setClosed(response.data.closed);
		setPending(response.data.ongoing);
	};

	useEffect(() => {
		fetchCaseCount();
	}, []);

	const form = useForm({
		defaultValues: {
			id: 1,
		},
	});

	return (
		<Form {...form}>
			<form className="w-full">
				<div className="flex flex-col w-full">
					<div className="grid grid-cols-12 w-full gap-4">
						<div className="col-span-6">
							<div className="flex flex-row w-full min-h-[100px] p-6 gap-3 rounded-md border border-border/50">
								<div className="inline-flex shrink-0 items-center justify-center w-[44px] h-[44px] mt-1 bg-red-50 text-red-600 rounded-full">
									<IconTrendingUp size={24} stroke={1.5} />
								</div>
								<div className="flex flex-col w-full">
									<span className="text-base text-foreground/70">Pending</span>
									<span className="font-bold text-xl text-foreground-dark">
										{pending ?? 0} Cases
									</span>
								</div>
							</div>
						</div>

						<div className="col-span-6">
							<div className="flex flex-row w-full min-h-[100px] p-6 gap-3 rounded-md border border-border/50">
								<div className="inline-flex shrink-0 items-center justify-center w-[44px] h-[44px] mt-1 bg-red-50 text-red-600 rounded-full">
									<IconTrendingUp size={24} stroke={1.5} />
								</div>
								<div className="flex flex-col w-full">
									<span className="text-base text-foreground/70">
										Case Closed
									</span>
									<span className="font-bold text-xl text-foreground-dark">
										{closed ?? 0} Cases
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</Form>
	);
}
